<template>
    <div class="posts__products-overview" :class="{ 'posts__products-overview--loading' : $store.state.loading }">
        <template class="posts__row" v-for="(category, index) in categories">
            <template v-if="categoryHasProducts(category.name)">
                <div class="flexible-section">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-10 offset-lg-1">
                                <div class="row">
                                    <div class="col-12">
                                        <h2 class="posts__category-title" v-if="category.name"
                                            v-html="category.name"></h2>
                                    </div>
                                    <div class="col-12 posts__row-desc">
                                        <p class="posts__category-desc" v-if="category.description"
                                           v-html="category.description"></p>
                                        <div class="posts__category-buttons" v-if="category.buttons">
                                            <template v-for="button in category.buttons">
                                                <template v-if="button.link">
                                                    <a :href="button.link.url"
                                                       class="button"
                                                       :class="buttonType(button.color)"
                                                       v-text="button.link.title"></a>
                                                </template>
                                            </template>
                                        </div>
                                    </div>
                                </div>

                                <template v-for="type in types">
                                    <template v-if="typeHasProducts(type.name, category.name)">
                                        <h4 class="posts__type-name" v-html="type.name"></h4>
                                        <div class="row gx-4 gx-lg-5 post-cards">
                                            <template v-for="post in ids_posts">
                                                <template
                                                    v-if="showByCatAndType(post.product_category[0], post.product_type[0], category.name, type.name)">
                                                    <post-card v-bind:post="post"></post-card>
                                                </template>
                                            </template>
                                        </div>
                                    </template>
                                </template>

                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </template>
    </div>
</template>
<script>

import PostCard from "./PostCard.vue";
import axios from "axios";

export default {

    props: {
        ids_posts: {
            type: Array
        }
    },
    data() {
        return {
            categories: [],
            types: []
        }
    },
    components: {
        'post-card': PostCard,
    },
    methods: {
        categoryHasProducts(categoryName) {
            let productCount = 0;
            this.ids_posts.forEach((post, index) => {
                if (post.product_category[0] === categoryName) {
                    productCount++
                }
            });
            return productCount > 0;
        },
        typeHasProducts(typeName, categoryName) {
            let productCount = 0;
            this.ids_posts.forEach((post, index) => {
                if (post.product_type[0] === typeName && post.product_category[0] === categoryName) {
                    productCount++
                }
            });
            return productCount > 0;
        },
        showByCatAndType(postCategory, postType, rowCategory, rowType) {
            if (postCategory === rowCategory && postType === rowType) {
                // console.log(postCategory, postType, rowCategory, rowType);
                return true;
            }
        },
        getAllProductTypeTerms() {
            // FIRST
            // Get all product_types terms, we need this to create separate section for each category.
            let _this = this;

            let fetchUrl = this.$store.state.baseUrl;
            fetchUrl += '/wp-json/wp/v2/product_type';

            return axios.get(fetchUrl)
                .then(response => {
                    response.data.forEach((type) => {
                        let rowObject = {
                            name: type.name,
                            order: type.acf.type_order - 1,
                            items: []
                        }

                        _this.types[rowObject.order] = rowObject;
                        // _this.types.push(rowObject);
                    });
                })
                .catch(e => {
                    console.log(e);
                });
        },
        getAllProductCatTerms() {
            // SECOND
            // Get all product_category terms, we need this to create separate section for each category.
            let _this = this;

            let fetchUrl = this.$store.state.baseUrl;
            fetchUrl += '/wp-json/wp/v2/product_category';

            return axios.get(fetchUrl)
                .then(response => {

                    response.data.forEach((category) => {
                        let rowObject = {
                            name: category.name,
                            description: category.description,
                            buttons: category.acf.buttons,
                            order: category.acf.category_order - 1
                        }

                        this.categories[rowObject.order] = rowObject;
                        // _this.categories.push(rowObject);
                    });
                })
                .catch(e => {
                    console.log(e);
                });
        },
        buttonType(type) {
            console.log('button', type);
            return type;
        }
    },
    created() {
        this.getAllProductTypeTerms();
        this.getAllProductCatTerms();
    }
}
</script>
